export enum UMC_ERROR_REASONS {
	ACTION_CANCELLED = 'ACTION_CANCELLED'
}
